module.exports = "/images/vendor/leaflet/dist/marker-icon-2x.png?680f69f3c2e6b90c1812a813edf67fd7";